var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"m-5"},[_vm._v("Funcionalidade ainda não implementada.")])}
var staticRenderFns = []

export { render, staticRenderFns }